import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { first } from 'rxjs/operators';

import { UserService } from '@services/api/user/user.service';
import { RouterService } from '@services/router.service';
import { LoaderComponent } from '@shared/loader/loader.component';
import { InfoBoxComponent } from '@shared/info-box/info-box.component';
import { RoleRoutePermissions, Route } from '@constants/route';

@Component({
    templateUrl: 'app.page.component.html',
    host: { class: 'p-3' },
    imports: [MatIconModule, LoaderComponent, InfoBoxComponent],
})
export class AppPageComponent implements OnInit {
    missingUserRole = false;
    notAuthorizedUserRole = false;

    private readonly router = inject(Router);
    private readonly userService = inject(UserService);
    private readonly routerService = inject(RouterService);

    ngOnInit(): void {
        this.checkUserRole();
    }

    private checkUserRole() {
        this.userService
            .getUser()
            .pipe(first())
            .subscribe({
                next: (user) => {
                    if (user) {
                        const role = user.role;

                        if (role === null) {
                            this.missingUserRole = true;
                        } else {
                            const defaultRoute =
                                RoleRoutePermissions[role].defaultRoute;
                            if (defaultRoute) this.navigate(defaultRoute);
                            else this.notAuthorizedUserRole = true;
                        }
                    }
                },
                error: (err: HttpErrorResponse) => {
                    this.routerService.goErrorPage(err);
                },
            });
    }

    private navigate(route: Route[]) {
        this.router.navigate(route);
    }
}
